import React, {useEffect, useState} from 'react';
import {useMatch, useParams, useSearchParams} from "react-router-dom";
import {CourseService} from "../../service/CourseService";
import {ProgressSpinner} from "primereact/progressspinner";
import GeneralUtils from "../../utils/GeneralUtils";
import {CategoryService} from "../../service/CategoryService";
import {SubcategoryService} from "../../service/SubcategoryService";
import {Divider} from "primereact/divider";
import {SearchService} from "../../service/SearchService";
import {LabelService} from "../../service/LabelService";
import BreadcrumbThree from "../../components/breadcrumb/breadcrumb-3";
import CourseTypeFive from "../../components/course/course-type-five";

const CategoryCourses = () => {
    const [data, setData] = useState(null);
    const [title, setTitle] = useState(null);
    const [displayFilters, setDisplayFilters] = useState(false);

    const match = useMatch("/courses/search");
    const [searchParams, setSearchParams] = useSearchParams();
    const {categoryId, subcategoryId, labelId} = useParams();

    const service = new CourseService();
    const categoryService = new CategoryService();
    const subcategoryService = new SubcategoryService();
    const labelService = new LabelService();
    const searchService = new SearchService();

    useEffect(() => {
        // service.checkPage();
    }, []);

    useEffect(() => {
        // service.findAll().then(response => setData(response));

        if(match){
            let phrase = searchParams.get("q");
            if(!GeneralUtils.isNullOrEmpty(phrase)){
                searchService.suggestions(phrase).then(response => setData(response));
            }
        } else{
            if(!GeneralUtils.isNullOrEmpty(labelId)){
                labelService.findById(labelId).then(response => setTitle(response.title));
                service.findByLabelId(labelId).then(response => setData(response));

            } else if(!GeneralUtils.isNullOrEmpty(subcategoryId)){
                subcategoryService.findById(subcategoryId).then(response => setTitle(response.title));
                service.findBySubcategoryId(subcategoryId).then(response => setData(response));

            } else if(!GeneralUtils.isNullOrEmpty(categoryId)){
                categoryService.findById(categoryId).then(response => setTitle(response.title));
                service.findByCategoryId(categoryId).then(response => setData(response));
            } else{
                service.findAll().then(response => setData(response));
            }
        }

    }, [searchParams, categoryId, subcategoryId, labelId]);

    return (
        <>
            <BreadcrumbThree title={!match ? (title ? (title +  ' Kursları') : 'Tüm Kurslar') : ('"' + searchParams.get("q") + '" için sonuç' || null)}
                             subtitle="" />
            <div className="edu-course-area course-area-1">
                <div className="container">
                    <div className="row g-5">
                    {/*<div className="container">*/}
                        {/*<div className="top-container">*/}
                        {/*    <div className="top-container-title"> {!match ? (title ? <h1>{title} Kursları</h1> : <h1>Tüm Kurslar</h1>) : (<h1>"{searchParams.get("q")}" için sonuç</h1> || null)}</div>*/}
                        {/*</div>*/}
                        {/*<div className="content">*/}
                            {/*<Divider/>*/}

                            {/*<Button icon='pi pi-filter' label="Filtrele" severity="secondary" outlined size="small"*/}
                            {/*        className="button-white" onClick={() => setDisplayFilters((prev) => !prev)}/>*/}

                            {/*<div className="category-course-page">*/}
                            {/*    <div className={["left", !displayFilters ? "leftW" : null].join(" ")}>*/}

                            {/*    </div>*/}
                            {/*    <div className={["right", !setDisplayFilters ? "rightW" : null].join(" ")}>*/}
                            {data ? data.map((row, index) => (<CourseTypeFive key={index} data={row} />))
                                : <ProgressSpinner style={{width: '60px', height: '60px'}} strokeWidth="6"/>}
                            {/*{data ? data.map((row, index) => (<CourseCardList key={index} data={row}/>))*/}
                            {/*    : <ProgressSpinner style={{width: '60px', height: '60px'}} strokeWidth="6"/>}*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        {/*</div>*/}
                    {/*</div>*/}
                    </div>
                </div>
            </div>
        </>
    );
};

export default CategoryCourses;
